/**
 * MeetingSummaryModal - Модальное окно для добавления итогов встречи
 */
import React, { useState, useEffect } from 'react';
import {
  Modal,
  Textarea,
  Button,
  Group,
  Stack,
  Alert,
  Text,
} from '@mantine/core';
import { IconAlertCircle, IconClipboardText } from '@tabler/icons-react';

const MeetingSummaryModal = ({
  opened,
  onClose,
  onConfirm,
  loading = false,
  meeting = null,
}) => {
  const [summary, setSummary] = useState('');
  const [error, setError] = useState(null);

  // Сброс формы при открытии/закрытии
  useEffect(() => {
    if (opened) {
      setSummary(meeting?.summary || '');
      setError(null);
    }
  }, [opened, meeting]);

  const handleConfirm = async () => {
    if (!summary.trim()) {
      setError('Введите итоги встречи');
      return;
    }

    try {
      await onConfirm(summary.trim());
    } catch (err) {
      setError(err.message || 'Ошибка при сохранении итогов');
    }
  };

  // Форматирование списка контактов
  const formatContactNames = () => {
    if (!meeting?.contacts || meeting.contacts.length === 0) {
      return 'без контактов';
    }
    return meeting.contacts.map(c => {
      const parts = [];
      if (c.last_name) parts.push(c.last_name);
      if (c.first_name) parts.push(c.first_name);
      return parts.join(' ') || 'Без имени';
    }).join(', ');
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Добавить резюме встречи"
      centered
      size="md"
      radius="xl"
      styles={{
        content: {
          borderRadius: '16px',
        },
      }}
    >
      <Stack gap="md">
        {meeting && (
          <Text size="sm" c="dimmed">
            Встреча с {formatContactNames()}
          </Text>
        )}

        {error && (
          <Alert icon={<IconAlertCircle size={16} />} color="red" variant="light">
            {error}
          </Alert>
        )}

        <Textarea
          label="Итоги встречи"
          placeholder="Опишите результаты встречи, договорённости, следующие шаги..."
          required
          autosize
          minRows={6}
          maxRows={12}
          value={summary}
          onChange={(e) => setSummary(e.target.value)}
          leftSection={<IconClipboardText size={16} style={{ marginTop: '8px' }} />}
          leftSectionProps={{ style: { alignItems: 'flex-start' } }}
        />

        <Group justify="flex-end" gap="sm">
          <Button
            variant="subtle"
            onClick={onClose}
            disabled={loading}
          >
            Отмена
          </Button>
          <Button
            color="green"
            leftSection={<IconClipboardText size={16} />}
            onClick={handleConfirm}
            loading={loading}
          >
            Сохранить итоги
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default MeetingSummaryModal;
